import ACTION_TYPES from "../actions/actionTypes";

export default (state, action) => {
  let keys = ["employeeID"];
  switch (action.type) {
    case ACTION_TYPES.FETCH_TARGETSTATE_A3:
      return { ...state, targetStateA3Data: action.payload };
    case ACTION_TYPES.FETCH_ATTACHMENT_A3:
      return { ...state, attachmentsA3: action.payload };
    case ACTION_TYPES.FETCH_A3_DATA:
      return {
        ...state,
        strategicA3Data: action.payload,
        lastSavedTab: action.payload.lastSaved,
      };
    case ACTION_TYPES.FETCH_A3_GAP_DATA:
      return { ...state, a3GAPData: action.payload };
    case ACTION_TYPES.FETCH_A3_GAP_SOLUTION_DATA:
      return { ...state, a3GAPSolutionData: action.payload };
    case ACTION_TYPES.FETCH_A3_GAP_ANALYSIS_DATA:
      return { ...state, gapAnalysisStateA3Data: action.payload };
    case ACTION_TYPES.FETCH_EXPERIMENT_A3:
      return { ...state, rapidExperimentData: action.payload };
    case ACTION_TYPES.MANAGE_EXPERIMENTS_DATA:
      return { ...state, ManageRapidExperimentData: action.payload };
    case ACTION_TYPES.FETCH_PEOPLE:
      return {
        ...state,
        peopleList: action.payload,
      };
    case ACTION_TYPES.FETCH_A3_COMPLETION_PLAN:
      return { ...state, sa3CompletionPlan: action.payload };
    case "USER_PREF_SETTINGS":
      return { ...state, userPrefSettings: action.payload };
    case ACTION_TYPES.FETCH_A3_GRID_DATA:
      return { ...state, sa3GridData: action.payload };
    case ACTION_TYPES.FETCH_A3_CONFIRMEDRESULTS:
      return { ...state, confirmedResultsData: action.payload };
    case ACTION_TYPES.FETCH_A3_CONFIRMEDRESULTS_GRAPH:
      return { ...state, confirmedResultsGraphData: action.payload };
    case "FETCH_A3_PRINT_DATA":
      return { ...state, printInfoA3: action.payload };
    case "A3_TEAM_MEM":
      return { ...state, a3TeamMemers: action.payload };
    default:
      return state;
  }
};
